import { Table } from '~/components/ui/Table';
import { $LOADER, $PAGE } from "~/util/Loaders";
import { homePage } from "~/util/titles";

const SERVERS: { name: string; img: string; hud: number; features: { autologin?: boolean; chat?: boolean; npcinfo?: boolean; }; }[] = [{
  name: "ElmoreLab x1", img: "https://forum.elmorelab.com/data/assets/logo/logo_big.png", hud: 13, features: { autologin: true, chat: true, npcinfo: true }
}, { name: "Keltir x1", hud: 12, img: "https://keltir.com/img/logos/header_logo.png", features: { autologin: true, npcinfo: true } }];

$PAGE({
  path: "hud/servers",
  loader: $LOADER?.(async () => null),
  meta: (cx) => {
    const title = "L2hub Servers";

    return {
      title: `${title} - ${homePage(cx.realm)}`,
      description: "L2hub Servers",
    };
  },
  render: () => {
    return <div>
      <Table id={(SERVERS, index) => index} data={SERVERS} cols={[
        {
          title: "",
          cell: (server) => <img src={server.img} alt={server.name} style={{ height: 40 }} />,
          thPadding: "0",
          padding: "8px 0 8px 8px",
          width: 32 + 12,
          align: "center"
        },
        {
          title: "Name",
          cell: (server) => server.name,
        },
        {
          title: "Auto-login",
          cell: (server) => server.features.autologin ? "+" : null,
        },
        {
          title: "Chat",
          cell: (server) => server.features.chat ? "+" : null,
        },
        {
          title: "Npc Info",
          cell: (server) => server.features.npcinfo ? "+" : null,
        },
        {
          title: "Hud Version",
          cell: (server) => <a href={`http://localhost:3000/addon/get/l2hub-v${server.hud}.zip`}>HUD v.{server.hud}</a>,
        },
      ]} />
    </div>;
  },
});
